/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import ContentAnswer from 'components/content/shared/questionset/shared/answer/answer';
import { setAnswerClicked, advanceFrameWithStatus, advanceFrame } from 'redux/actions/content_status'
import { displayScreen } from 'redux/actions/screen_status';
import { awardPoints, awardPointsWithRewards } from 'redux/actions/rewards';
import { requestQuestionResponseResult } from 'redux/actions/content_status';
import { showLoader } from 'redux/actions/embed_status';



/* ========== ~~~~~~~~~~ ContentAnswer : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ settings, contentStatus, contentData, rewards, sessionStatus }, { contentId, isCorrectAnswer, frame, answer }) => {
    const currentContentData = contentData[contentId];
    const currentContentSettings = settings.contentSettings[contentId];
    const currentContentStatus = contentStatus[contentId].uniqueState;
    const uniqueProps = currentContentSettings.uniqueProps;
    const showResultForXSeconds = uniqueProps.showResultForXSeconds;
    const chosenAnswer = currentContentStatus.chosenAnswers[frame];
    const answerStatus = currentContentStatus.frameStatus[frame]['options'][answer.id];
    const isCorrect = answerStatus.isCorrect;
    const frameData = currentContentData.data[frame];
    const frameType = currentContentData.data[frame]["type"];
    const frameState = currentContentStatus.frameStatus[frame].state;
    const validRequest = currentContentStatus.frameStatus[frame].validRequest;
    const question = frameData.question;
    const questionSignature = frameData.questionSignature;
    return {
        chosenAnswer,
        embedUUID: settings.embedSettings.embedUUID,
        frame,
        frameData,
        frameState,
        frameType,
        isCorrect,
        isPreview: settings.embedSettings.isPubPortalPreview,
        isPubPortalPreview: settings.embedSettings.isPubPortalPreview,
        question,
        questionSignature,
        rewardsSettings: rewards.settings,
        rewardsStatus: rewards.status,
        siteUUID: settings.embedSettings.site.uuid,
        showResultForXSeconds,
        uniqueProps,
        userId: sessionStatus.userInfo.userId,
        validRequest
    }
};


const mapDispatchToProps = dispatch => ({
    advanceFrame: (contentId) => dispatch(advanceFrame(contentId)),
    awardPoints: (numberOfPoints) => dispatch(awardPoints(numberOfPoints)),
    awardPointsWithRewards: (numberOfPoints, numberOfRewards, rewardsPhase) =>
        dispatch(awardPointsWithRewards(numberOfPoints, numberOfRewards, rewardsPhase)),
    displayScreen: (screen) => dispatch(displayScreen(screen)),
    requestQuestionResponseResult: (contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview) =>
        dispatch(requestQuestionResponseResult(contentId, frame, isFactualQuestion, responseDetails, isPubPortalPreview)),
    setAnswerClicked: (contentId, frame, predictionOptionUUID) => dispatch(setAnswerClicked(contentId, frame, predictionOptionUUID)),
    showLoader: state => dispatch(showLoader(state))
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentAnswer);
